import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import InputBase from "@mui/material/InputBase";
import { useTheme } from "@mui/material/styles";
import { Icon } from "@/components/atoms/Icon";
import type { CommentSectionProps } from "./CommentSection.types";

const CommentSection: React.FC<CommentSectionProps> = ({
  value,
  onChange,
  placeholder,
  maxLength = 200,
  disabled = false,
  label = "Комментарий к предзаказу",
}) => {
  const theme = useTheme();

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = event.target.value;
    if (newValue.length <= maxLength) {
      onChange(newValue);
    }
  };

  // return (
  //   <TextField
  //     value={value}
  //     onChange={handleChange}
  //     placeholder={placeholder}
  //     label={label}
  //     disabled={disabled}
  //     multiline
  //     sx={{
  //       backgroundColor: theme.palette.action.hover,
  //       borderRadius: 3,
  //     }}
  //   />
  // );

  return (
    <Box
      sx={{
        backgroundColor: theme.palette.action.hover,
        borderRadius: 3,
        width: "100%",
        minHeight: 64,
      }}
    >
      <Box
        sx={{
          display: "flex",
          alignItems: "flex-start",
          padding: "12px",
          gap: 2,
        }}
      >
        {/* Icon Section */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            paddingTop: 0.5,
          }}
        >
          <Icon name="messageDotsSquare" size={22} />
        </Box>

        {/* Input Section */}
        <Box
          sx={{
            flex: 1,
            display: "flex",
            flexDirection: "column",
          }}
        >
          {/* Label */}
          <Typography
            variant="caption"
            sx={{
              fontSize: 11,
              opacity: 0.5,
            }}
          >
            {label}
          </Typography>

          {/* Input */}
          <InputBase
            value={value}
            onChange={handleChange}
            placeholder={placeholder}
            disabled={disabled}
            multiline
            maxRows={3}
            inputProps={{
              maxLength: maxLength,
              "aria-label": label,
              "aria-describedby": "comment-helper-text",
            }}
            sx={{
              fontSize: "14px",
              fontWeight: 500,
              color: theme.palette.text.primary,
              lineHeight: 1.4,
              padding: 0,
              "& .MuiInputBase-input": {
                padding: 0,
                "&::placeholder": {
                  color: theme.palette.text.primary,
                  opacity: 0.7,
                },
              },
            }}
          />
        </Box>
      </Box>
    </Box>
  );
};

export default CommentSection;
